import { apiSlice } from "./apiSlice";

export const capitalCorpApi = apiSlice.injectEndpoints({
    endpoints: (build) => ({
        // 캐피탈 업체 조회
        getCapitalCorp: build.query({
            query: () => ({
                url: "/api/user/capital_corp/v1",
                method: "get",
                headers: { token: true },
            }),
        }),
    }),
});

export const { useGetCapitalCorpQuery } = capitalCorpApi; 